import videojs from 'video.js';
const Component = videojs.getComponent('Component');
const MenuItem = videojs.getComponent('MenuItem');

/**
 * The menu item component for QualitySwitcherButton
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends MenuItem
 */
class QualitySwitcherItem extends MenuItem {
  constructor(player, options) {
    // Modify options for parent MenuItem class's init.
    options.label = options.quality.label;
    options.selected = options.quality.selected;
    options.selectable = true;

    super(player, options);

    this.quality = options.quality;
    this.qualities_list = options.qualities_list;
    
    this.remember_quality = options.remember_quality;

    const handler = this.handleListChange.bind(this);
    this.qualities_list.on('change_selected', handler);
    this.on('dispose', () => this.qualities_list.off('change_selected', handler));
  }

  handleClick(event) {
    super.handleClick(event);
    this.qualities_list.selectQuality(this.quality, 'user_click', this.remember_quality);
  }

  handleListChange() {
    this.selected(this.quality.selected);
  }
}

Component.registerComponent('QualitySwitcherItem', QualitySwitcherItem);
export default QualitySwitcherItem;
